import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';
import { selectAuth } from 'src/app/store/auth/auth.selector';
import { TokenAuthState } from 'src/app/store/auth/auth.state';
import { ApiService } from './api-services/api.service';
import dayjs from 'dayjs';
@Injectable({
  providedIn: 'root',
})
export class SharedService {
  auth$: TokenAuthState;
  spinner = false;
  selectedLan = new BehaviorSubject('');
  rewardQty = new BehaviorSubject([{ rewardId: null, qty: 1 }]);
  registerData = new BehaviorSubject([]);
  tabSelect = new BehaviorSubject<any>('');
  reactedOnComment = new BehaviorSubject({ postId: null, status: false });
  iframeTokenDetails = new BehaviorSubject({
    session_token: null,
    redirect_url: '',
  });

  constructor(
    private store: Store,
    private api: ApiService,
  ) {
    this.store.pipe(select(selectAuth)).subscribe((auth) => {
      this.auth$ = auth;
    });
  }

  isLogin() {
    if (!!this.auth$?.auth?.token) {
      return dayjs().isSame(this.auth$?.tokenDate, 'day');
    }
    return false;
  }

  setRegisterData(data: any) {
    this.registerData.next(data);
  }

  getRegisterData() {
    return this.registerData.asObservable();
  }

  isInIframe() {
    return window.self !== window.top;
  }
}
